import { createSlice } from "@reduxjs/toolkit";
// import { sideBarMenuAllOptions } from "@/src/constants/sidebarOld";
// import { ISideBarComputedList, ISideBarList, ISideBarListItemObj } from "@/src/types/sideBar";

// interface ISideBarMovePayload {
//   id: string;
//   direction: "plus" | "minus";
// }

// interface ISideBarMenuSlice {
//   SiderBarConfig: {
//     list: ISideBarComputedList;
//     isOpen: boolean;
//   };
// }

// const userConfigRow = localStorage.getItem("userConfig");

// const safeParse = (raw: string | null) => {
//   try {
//     return raw ? JSON.parse(raw) : null;
//   } catch {
//     return null;
//   }
// };

// const normalizeList = (listPartial?: Partial<ISideBarList>): ISideBarList => {
//   return {
//     main: (listPartial && listPartial.main) || [],
//     tools: (listPartial && listPartial.tools) || [],
//     adminPanel: (listPartial && listPartial.adminPanel) || [],
//   };
// };

// const computeSideBarList = (activeList: ISideBarList, allList: ISideBarList): ISideBarComputedList => {
//   return {
//     main: {
//       active: activeList.main || [],
//       nonActive: allList.main.filter((itemAll) => !(activeList.main || []).some((itemActive) => itemActive.id === itemAll.id)),
//     },
//     tools: {
//       active: activeList.tools || [],
//       nonActive: allList.tools.filter((itemAll) => !(activeList.tools || []).some((itemActive) => itemActive.id === itemAll.id)),
//     },
//     adminPanel: {
//       active: activeList.adminPanel || [],
//       nonActive: allList.adminPanel.filter((itemAll) => !(activeList.adminPanel || []).some((itemActive) => itemActive.id === itemAll.id)),
//     },
//   };
// };

// const parsedOptions = safeParse(userConfigRow);

// const userSideBarList: ISideBarList = parsedOptions?.SideBarConfig?.list
//   ? normalizeList(parsedOptions.SideBarConfig.list as Partial<ISideBarList>)
//   : sideBarMenuAllOptions;
// : ISideBarMenuSlice

const initialState = {
  // SiderBarConfig: {
  //   list: computeSideBarList(userSideBarList, sideBarMenuAllOptions),
  //   isOpen: parsedOptions && typeof parsedOptions.SideBarConfig?.isOpen === "boolean" ? parsedOptions.SideBarConfig.isOpen : true,
  // },
};

const sideBarMenuSliceOld = createSlice({
  name: "sideBarMenuSlice",
  initialState,
  reducers: {
    // sideBarSwitchItem(state, action: PayloadAction<ISideBarMovePayload>) {
    //   const { id, direction } = action.payload;
    //   Object.values(state.SiderBarConfig.list).forEach((section) => {
    //     const fromArray = direction === "plus" ? section.nonActive : section.active;
    //     const toArray = direction === "plus" ? section.active : section.nonActive;
    //     const foundIndex = fromArray.findIndex((item: ISideBarListItemObj) => item.id === id);
    //     if (foundIndex !== -1) {
    //       const [movedItem] = fromArray.splice(foundIndex, 1);
    //       const alreadyExists = toArray.some((item: ISideBarListItemObj) => item.id === id);
    //       if (!alreadyExists) {
    //         toArray.push(movedItem);
    //       }
    //     }
    //   });
    // },
    // sideBarIsSwitch(state, action: PayloadAction<boolean>) {
    //   state.SiderBarConfig.isOpen = action.payload;
    // },
  },
});
// sideBarSwitchItem, sideBarIsSwitch
// export const {} = sideBarMenuSliceOld.actions;
export default sideBarMenuSliceOld.reducer;
